import { KeyToNoteNumberType } from '../../types/visualizer'

// Keyboard key to visualizer note (1-88) bindings
export const KeyToNoteNumber: KeyToNoteNumberType[] = [
  { key: 'S', noteNumber: 27 },
  { key: 'H', noteNumber: 28 },
  { key: 'J', noteNumber: 29 },
  { key: 'K', noteNumber: 30 },
  { key: 'L', noteNumber: 31 },
  { key: 'Z', noteNumber: 32 },
  { key: 'X', noteNumber: 33 },
  { key: 'V', noteNumber: 34 },
  { key: 'N', noteNumber: 35 },
  { key: 'M', noteNumber: 36 },
  { key: 'A', noteNumber: 37 },
  { key: 'B', noteNumber: 39 },
  { key: 'C', noteNumber: 40 },
  { key: 'D', noteNumber: 42 },
  { key: 'E', noteNumber: 44 },
  { key: 'F', noteNumber: 45 },
  { key: 'G', noteNumber: 47 },
  { key: 'Q', noteNumber: 48 },
  { key: 'W', noteNumber: 49 },
  { key: 'R', noteNumber: 50 },
  { key: 'T', noteNumber: 51 },
  { key: 'Y', noteNumber: 52 },
  { key: 'U', noteNumber: 53 },
  { key: 'I', noteNumber: 54 },
  { key: 'O', noteNumber: 55 },
  { key: 'P', noteNumber: 56 },
]
